import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"
import csvToHtml from "utils/csvToHtml"

import Table from "components/table"
import ContentfulButton from "./button"

const ContentfulTable = ({ component, nested, elRef }) => {
  const heading = component.heading
    ? component.heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
    : ""
  const subheading = component.subheading ? component.subheading.childMarkdownRemark.html : ""

  const tableData = component.tableData
    ? component.tableDataFormat === "CSV"
      ? csvToHtml(component.tableData.tableData, { hasHeader: component.dataHasHeaderRow })
      : component.tableDataFormat === "Markdown"
      ? component.tableData.childMarkdownRemark.html
      : ""
    : ""

  return (
    <ThemeProvider
      theme={componentThemeExtension(!nested ? component.backgroundColor : null, nested)}
    >
      <Table
        dataId={component.id}
        elRef={elRef}
        heading={heading}
        subheading={subheading}
        tableData={tableData}
        displayTrueFalseAsCheckmarks={Boolean(component.displayTrueFalseAsCheckmarks)}
        dataHasHeaderRow={Boolean(component.dataHasHeaderRow)}
        headerRowColor={component.headerRowColor}
        evenRowColor={component.evenRowColor}
        oddRowColor={component.oddRowColor}
        headerAlign={component.headerAlign}
        cellAlign={component.cellAlign}
        firstColumnAlign={component.firstColumnAlign}
        lastColumnAlign={component.lastColumnAlign}
        fullWidth={component.fullWidth}
        lockFirstColumnOnMobile={component.lockFirstColumnOnMobile}
        navigationAnchor={component.navigationAnchor && component.navigationAnchor.anchorId}
        button={component.ctaButton && <ContentfulButton component={component.ctaButton} />}
        hideOnPageLoad={Boolean(component.hideOnPageLoad)}
      />
    </ThemeProvider>
  )
}

export default ContentfulTable
